'use client';

import React, { FC, JSX, useEffect, useState } from 'react';
import ImageGallery, { ImageGalleryProps } from '@/components/imageGallery/ImageGallery';
import { useSearchParams } from 'next/navigation';
import short from 'short-uuid';

const ImageGalleryWrapper: FC<ImageGalleryProps> = (props: ImageGalleryProps): JSX.Element => {
  const searchParams = useSearchParams();
  const [imageGalleryId, setImageGalleryId] = useState<string>('');

  useEffect(() => {
    setImageGalleryId(short.generate());
  }, [searchParams]);

  return <ImageGallery key={imageGalleryId} {...props} />;
};

export default ImageGalleryWrapper;
